import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

const Faq = ({ fetchCourse }) => {
    const [showAll, setShowAll] = useState(false);
    const [current, setCurrent] = useState(null); // Default: No selection

    const QA = fetchCourse?.faqs?.length > 0 ? fetchCourse.faqs : [
        { id: 0, question: "What is yslearn.in?", answer: "yslearn.in is a suite of online teaching tools..." },
        { id: 1, question: "What does it cost to take a course?", answer: "Our courses range from free to $500..." },
        { id: 2, question: "Does yslearn.in provide certification?", answer: "Yes, instructors can issue completion certificates..." },
        { id: 3, question: "How can I enroll in a course?", answer: "You can enroll by visiting the course page and clicking Enroll Now." },
        { id: 4, question: "Can I access courses on mobile?", answer: "Yes, all courses are mobile-friendly and can be accessed anytime." },
        { id: 5, question: "What payment methods do you accept?", answer: "We accept Visa, Mastercard, PayPal, and other payment options." },
        { id: 6, question: "Do courses have a time limit?", answer: "Most courses have lifetime access unless otherwise specified." },
        { id: 7, question: "Can I get a refund?", answer: "Refunds are available within 14 days of purchase under certain conditions." },
        { id: 8, question: "Is there support for students?", answer: "Yes, we have a dedicated support team for student queries." },
    ];

    const visibleFaqs = showAll ? QA : QA.slice(0, 6);

    const toggleFaq = (index) => {
        setCurrent(current === index ? null : index);
    };

    return (
        <section id="faqs">
            <div className="max-w-7xl px-6 mx-auto py-5">
                <h2 className="text-2xl font-semibold text-gray-800 text-left mb-6">
                    {fetchCourse?.CourseName} <span className="font-extrabold">FAQs</span>
                </h2>

                <div>
                    {visibleFaqs.map((item, index) => (
                        <div key={item.id} className="border rounded-lg shadow-md mb-4">
                            <button
                                className={`w-full text-left px-5 py-4 flex justify-between items-center 
                                ${current === index ? "bg-white text-black" : "bg-gray-100 text-gray-900"} 
                                hover:bg-gray-200 cursor-pointer transition`}
                                onClick={() => toggleFaq(index)}
                            >
                                <span className={`${current === index ? "font-bold" : "font-medium"}`}>{item.question}</span>
                                <FaChevronDown className={`transition-transform ${current === index ? "rotate-180" : ""}`} />
                            </button>
                            {current === index && (
                                <div className="px-5 py-3 bg-white text-gray-700">
                                    {item.answer}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {QA.length > 6 && (
                    <div className="text-center mt-6">
                        <button
                            className="text-blue-600 hover:underline font-semibold"
                            onClick={() => setShowAll(!showAll)}
                        >
                            {showAll ? "Show Less" : "View More"}
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default Faq;
